module.exports = __webpack_public_path__ + "img/the_shrieking_shack.48ee5e37.jpg";